import { uniqBy } from 'lodash';
import { Maybe } from '../graphql/generated';

interface CachePaginatedListVariables {
  input: {
    offset?: Maybe<number>;
  };
}

export interface CachePaginatedEntry {
  items: unknown[];
}

export const cacheMergePaginatedList = <V extends CachePaginatedListVariables>(
  existing: CachePaginatedEntry,
  incoming: CachePaginatedEntry,
  variables?: V
): CachePaginatedEntry => {
  const input = variables?.input;
  const isFirstPage = input?.offset === undefined || input?.offset === 0;
  if (existing?.items && !isFirstPage) {
    const items = uniqBy([...existing.items, ...incoming.items], '__ref');
    return {
      ...existing,
      items,
    };
  } else {
    return incoming;
  }
};
